import { 
CAPITAL_MARKET_ASSUMPTIONS_RECEIVED,
RUNNING_CUSTOM_CMA_SCRIPT,
CMA_DATES,
ON_ASSET_SET_CHANGED,
LOGOUT,
PROFILE_RESET
} from '../actions/types/actions';
import { Asset, AssetSet, CMAAsset } from '../actions/types/customAssets';

export interface CapitalMarketAssumptionState {
    assets: Asset[],
    cma_assets: CMAAsset[],
    asset_sets: AssetSet[],
    start_date?: string,
    end_date?: string,
    running_script: boolean,
    selectedAssetSet?: AssetSet | null
};

const INITIAL_STATE: CapitalMarketAssumptionState = {
    assets: [],
    cma_assets: [],
    asset_sets: [],
    start_date: undefined,
    end_date: undefined,
    running_script: false,
    selectedAssetSet: null
};

export default (state = INITIAL_STATE, action): CapitalMarketAssumptionState => {
  const { payload, type } = action

  switch (type) {
    case CAPITAL_MARKET_ASSUMPTIONS_RECEIVED:
        return { ...state, ...payload }
    case CMA_DATES:
        return { ...state, [payload.type]: payload.value }
    case RUNNING_CUSTOM_CMA_SCRIPT:
        return { ...state, running_script: payload }
    case ON_ASSET_SET_CHANGED:
        return { ...state, selectedAssetSet: payload}
    case PROFILE_RESET:
    case LOGOUT:
        return { ...INITIAL_STATE }
    default:
        return state;
  }
};

